import PropTypes from 'prop-types';
import DotsHorizontalIcon from '@untitled-ui/icons-react/build/esm/DotsHorizontal';
import Mail01Icon from '@untitled-ui/icons-react/build/esm/Mail01';
import User01Icon from '@untitled-ui/icons-react/build/esm/User01';
import {
  Avatar,
  Button,
  Card,
  CardContent,
  IconButton,
  InputAdornment,
  Stack,
  SvgIcon,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Unstable_Grid2 as Grid
} from '@mui/material';
import { Scrollbar } from '../../../components/scrollbar';
import { SeverityPill } from '../../../components/severity-pill';
import { Link, useParams } from 'react-router-dom';
import { collection, getFirestore, onSnapshot } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import { getStorage, ref, getDownloadURL, listAll } from 'firebase/storage';
import axios from 'axios';
import fileDownload from 'js-file-download';
import { LoadingButton } from '@mui/lab';

export const GrandeExpediente = (props) => {

  const params = useParams()
  const roomId = params.id

  const [pequenoExp, setPequenoExp] = useState([])
  const [loadingDownloads, setloadingDownloads] = useState(false)

  useEffect(() => {
    const db = getFirestore()
  
    const ordersRef = collection(db, 'users', `belacruz@eleg`, 'sessoes', `${roomId}`, 'grande-expediente')

    onSnapshot(ordersRef, (querySnapshot) => {
      const parsedData = querySnapshot.docs.map((doc) => {
        const data = doc.data()
        
        return { ...data }
      })
    
            //@ts-ignore
            function compararTimestamps(a, b) {
              return a.momento - b.momento;
            }
      
            //@ts-ignore
            setPequenoExp(parsedData.sort(compararTimestamps))
    })
  }, [])

  return (
    <Card>
      <CardContent>
        <Grid
          container
          spacing={3}
        >
          <Grid
            xs={12}
            md={8}
          >
            <Stack spacing={1}>
              <Typography variant="h6">
              Convidar parlamentares
              </Typography>
              <Typography
                color="text.secondary"
                variant="body2"
              >
                Atualmente, {pequenoExp.length >= 2 ? `${pequenoExp.length} parlamentares ` : `${pequenoExp.length} parlamentar `} cadastro no expediente.
              </Typography>
            </Stack>
          </Grid>
          <Grid
            xs={12}
            md={4}
            pt={2}
          >
            <Stack
              alignItems="center"
              justifyContent="right"
              direction="row"
            >
              <Link to={`/sessao/${roomId}/grande-expediente`} target="_blank" rel="noopener noreferrer">
                      <Button
                        color="primary"
                        size="large"
                        sx={{ mt: 2 }}
                        variant="contained"
                      >
                        Enviar link de convite
                      </Button>
                    </Link>
            </Stack>
          </Grid>
        </Grid>
      </CardContent>
      <Scrollbar>
        <Table sx={{ minWidth: 400 }}>
          <TableHead>
            <TableRow>
              <TableCell>
                Parlamentar
              </TableCell>
              <TableCell>
                Legislatura
              </TableCell>
              <TableCell>
                Arquivos
              </TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          
          <TableBody>
            {pequenoExp.map((item, index) => (
              <TableRow key={index}>
                <TableCell>
                  <Stack
                    alignItems="center"
                    direction="row"
                    spacing={2}
                  >
                    <Avatar
                      src={item.imageP}
                      sx={{
                        height: 40,
                        width: 40
                      }}
                    >
                      <SvgIcon>
                        <User01Icon />
                      </SvgIcon>
                    </Avatar>
                    <div>
                      <Typography variant="subtitle2">
                        {item.nome}
                      </Typography>
                      <Typography
                        color="text.secondary"
                        variant="body2"
                      >
                        {item.email}
                      </Typography>
                    </div>
                  </Stack>
                </TableCell>
                <TableCell>
                <Typography
                        color="text.secondary"
                        variant="body2"
                      >
                        {item.legislatura}
                      </Typography>
                </TableCell>
                <TableCell>

                <LoadingButton
                loading={loadingDownloads}
                 color="primary"
                 variant="outlined"
                 download
                 target="_blank"
                 rel="noopener noreferrer"
                 onClick={() => {

                  setloadingDownloads(true)

                  const storage = getStorage()

                  async function listFilesInFolder(folderPath) {
                    const folderRef = ref(storage, folderPath);
                    const files = await listAll(folderRef);
                  
                    const fileUrls = [];
                  
                    for (const file of files.items) {

                      const downloadURL = await getDownloadURL(file)

                      const xhr = new XMLHttpRequest()
                      xhr.responseType = 'blob';
                      xhr.onload = (event) => {
                        const blob = xhr.response;
                      
                        // Criar um URL local para o Blob
                        const blobUrl = URL.createObjectURL(blob);
                      
                        // Criar um link para fazer o download
                        const link = document.createElement('a');
                        link.href = blobUrl;
                        link.download = file.name; // Nome que você deseja dar ao arquivo
                      
                        // Adicionar o link ao DOM e simular o clique para iniciar o download
                        document.body.appendChild(link);
                        link.click();
                      
                        // Remover o link do DOM após o download iniciar
                        document.body.removeChild(link);
                      };
                      xhr.open('GET', downloadURL); // Substitua 'url' pelo URL que você já tem
                      xhr.send();
                    }
                  
                    return fileUrls;
                  }
                  
                  // Utilize a função para obter os URLs dos arquivos dentro da pasta
                  const folderPath = `users/belacruz@eleg/files/sessoes/${roomId}/${item.id}` // Substitua pelo caminho da sua pasta
                  listFilesInFolder(folderPath)
                  .catch(error => {
                    console.error('Erro ao obter os URLs:', error)
                  }).finally(() => {
                    setloadingDownloads(false)
                  })
              
                }}
               >
                 Baixar arquivos
               </LoadingButton>

                </TableCell>
                <TableCell align="right">
                  <IconButton>
                    <SvgIcon>
                      <DotsHorizontalIcon />
                    </SvgIcon>
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Scrollbar>
    </Card>
  );
}